import { useState } from 'react'
import styled from 'styled-components'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Box,
  Tabs,
  Tab,
} from '@mui/material'
import { Close, CloudDownload, CloudUpload } from '@mui/icons-material'
import { useImportActionsModal } from '../../contexts/ImportActionsModalContext'
import { useTranslation } from "react-i18next"

const BootstrapDialog = styled(Dialog)(() => ({
  '& .MuiDialogContent-root': {
    padding: 24,
  },
  '& .MuiDialogActions-root': {
    padding: 24,
    paddingBottom: 32,
  },
}))

const TabContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px 0;
`

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

function TabContent(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <TabContentContainer>{children}</TabContentContainer>}
    </div>
  )
}

const ImportActionsModal = ({ type }) => {
  const [selectedTab, setSelectedTab] = useState(0)
  const {
    open,
    closeModal,
    handleDownloadTemplate,
    handleUpload,
    handleFileChange,
    selectedFile,
    loading,
    handleResetFile,
  } = useImportActionsModal()
  const { t } = useTranslation('common')

  const handleChange = (_, newValue) => {
    handleResetFile()
    setSelectedTab(newValue)
  }

  return (
    <BootstrapDialog
      open={open}
      onClose={closeModal}
    >
      <DialogTitle>
        {t('import_actions.title')}
        <IconButton
          aria-label='close'
          onClick={closeModal}
          sx={{ position: 'absolute', right: 8, top: 8, color: '#000' }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={selectedTab}
              onChange={handleChange}
              aria-label='basic tabs example'
            >
              <Tab
                label={t('import_actions.template')}
                {...a11yProps(0)}
              />
              <Tab
                label={t('import_actions.upload')}
                {...a11yProps(1)}
              />
            </Tabs>
          </Box>
          <TabContent
            value={selectedTab}
            index={0}
          >
            <Button
              variant='contained'
              color='primary'
              onClick={() => handleDownloadTemplate(type)}
              sx={{ display: 'flex', gap: 1 }}
            >
              <CloudDownload />
              <span>{t('import_actions.template')}</span>
            </Button>
          </TabContent>
          <TabContent
            value={selectedTab}
            index={1}
          >
            <Button
              component='label'
              role={undefined}
              variant='contained'
              tabIndex={-1}
              startIcon={<CloudUpload />}
            >
              <input
                type='file'
                onChange={event => handleFileChange(event)}
                style={{ display: 'none' }}
              />
              <span>{t('import_actions.select')}</span>
            </Button>

            {selectedFile ? (
              <span
                title={selectedFile?.name}
                style={{
                  maxWidth: 380,
                  whiteSpace: 'wrap',
                }}
              >
                {t('import_actions.selected')} {selectedFile?.name}
              </span>
            ) : (
              <span>{t('import_actions.no_file')}</span>
            )}
          </TabContent>
        </Box>
      </DialogContent>
      {selectedTab === 1 && (
        <DialogActions>
          <Button
            onClick={() => handleUpload(type)}
            variant='contained'
            disabled={!selectedFile || loading}
          >
            {t('send')}
          </Button>
        </DialogActions>
      )}
    </BootstrapDialog>
  )
}

export default ImportActionsModal
